import React from 'react'
import { Doughnut } from 'Components/utilities/Chart'
import { PaymentData } from 'Store/dashboard/types'
import { menuPaymentType, menuPaymentTypePackageC, PaymentType } from 'helpers/constanst'
import { getIncomeChart, numberWithComma } from 'helpers/format'
import { Empty } from 'antd'

type Props = {
  paymentData?: PaymentData
  isPackageC: boolean
}

const IncomeChart: React.FunctionComponent<Props> = props => {
  const { paymentData, isPackageC } = props

  const getResult = () => {
    const label = [] as string[]
    const color = [] as string[]
    const value = [] as any[]
    const paymentType = isPackageC ? menuPaymentTypePackageC : menuPaymentType
    paymentType.forEach(item => {
      const type = getIncomeChart(item.value)
      const totalPrice = getValue(item.value)
      label.push(type.text)
      color.push(type.color)
      value.push(totalPrice)
    })
    return { label: label, color: color, value: value }
  }

  const getValue = (type: PaymentType) => {
    const result = paymentData?.success_payments.find(item => item.payment_type === type)
    return result?.total_price || 0
  }

  const isEmpty = (result: number[]) => {
    let empty = true as boolean
    result.forEach((item: number) => {
      if (item > 0) {
        empty = false
        return
      }
    })
    return empty
  }

  const result = getResult()

  const options = {
    responsive: true,
    legend: {
      display: false,
      position: 'right',
      align: 'middle',
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || 0
          const label = data.datasets[tooltipItem.datasetIndex].label[tooltipItem.index] || ''
          return `${label} ${numberWithComma(value, true)} บาท`
        },
      },
    },
  }

  const data = {
    labels: result.label,
    datasets: [
      {
        label: result.label,
        data: result.value,
        backgroundColor: result.color,
        borderWidth: 1,
      },
    ],
  }

  return !isEmpty(result.value) ? (
    <Doughnut data={data} options={options} />
  ) : (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      //description={<span>ไม่มีข้อมูลยอดขาย</span>}
    />
  )
}

export default IncomeChart
